import { memo, useEffect, useLayoutEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import classNames from 'classnames'
import { dfs } from 'shj-utils'
import { useSetState } from 'ahooks'
import useMenuRoute from '@/hooks/useMenuRoute.ts'
import { useLocation, useMatches, useNavigate } from 'react-router-dom'
import { Button, Col, Dropdown, Modal, Row } from 'antd'
import { MenuDownArrow } from '@/components/icons.tsx'
import { CloseOutlined, QuestionOutlined } from '@ant-design/icons'
import pathToRegexp from 'path-to-regexp'
import microApp, { removeDomScope } from '@micro-zoe/micro-app'
import { triggerEvent } from '@/utils/customEvent.ts'
import queryParse, { queryCompile } from '@/utils/queryParse.ts'

const MenuTop = memo(props => {
  const {
    selectedApp,
    selectedMenu,
    selectedSubMenu,
    updateSelectedMenu,
    updateSelectedSubMenu,
    menuLevel,
    setMenuLevel,
    routeHistory,
    saveRouteHistory,
  } = useGlobalStore(
    useShallow((state: any) => ({
      selectedApp: state.selectedApp,
      selectedMenu: state.selectedMenu,
      selectedSubMenu: state.selectedSubMenu,
      updateSelectedMenu: state.updateSelectedMenu,
      updateSelectedSubMenu: state.updateSelectedSubMenu,
      menuLevel: state.menuLevel,
      setMenuLevel: state.setMenuLevel,
      routeHistory: state.routeHistory,
      saveRouteHistory: state.saveRouteHistory,
    }))
  )

  const location = useLocation()
  const navigate = useNavigate()
  const menuBoxRef = useRef<any>()
  const menuRouteDict = useRef({})
  const routePathRef = useRef('')

  const [state, setState]: any[] = useSetState({
    subMenus: [],
    extraMenus: [],
  })
  const [mainMenuNumber, setMainMenuNumber] = useState(0)

  const { menuClick, setMenuKeys } = useMenuRoute()

  const setMenusNumber = () => {
    if (selectedApp?.children?.length) {
      const boxRect = menuBoxRef.current.getBoundingClientRect()
      let numbers = 0
      let widthCount = 0
      selectedApp?.children?.forEach((child, index) => {
        const itemWidth = (child.name?.length || 0) * 14 + 40 // 14: fontSize, 20: padding, 5: margin
        widthCount += itemWidth
        // 减app标题、叉叉图标、更多
        if (
          widthCount <
          boxRect.width - ((selectedApp?.name?.length + 1 || 0) * 18 + 60 + 52) - 40
        ) {
          numbers = index + 1
        }
      })

      setMainMenuNumber(numbers)
    }
  }

  const setSubMenus = () => {
    if (selectedMenu) {
      const subMenus: any[] = []
      const extraMenus: any[] = []
      const boxRect = menuBoxRef.current.getBoundingClientRect()
      let widthCount = 0
      dfs(selectedMenu.children, d => {
        // const children = d.children?.filter?.(d => d.type === 'menu')
        if (
          // d.level <= 2 && (!children || !children.length)
          d.level === 2
        ) {
          const itemWidth = (d.name?.length || 0) * 14 + 20 + 5 // 14: fontSize, 20: padding, 5: margin
          widthCount += itemWidth
          if (widthCount > boxRect.width - 80) {
            extraMenus.push(d)
          } else {
            subMenus.push(d)
          }
        }
      })
      if (
        !subMenus.length ||
        subMenus.length < 1 ||
        (subMenus.length === 1 && subMenus?.[0]?.name === selectedMenu?.name)
      ) {
        setMenuLevel(1)
      } else {
        setMenuLevel(2)
      }
      // console.log('subMenus', selectedMenu)
      setState({ subMenus, extraMenus })
    }
  }

  const getUrlBreadCrumb = parsedSearch => {
    return decodeURIComponent(parsedSearch['bread'] || '')
      .split(',')
      .filter(d => d)
  }

  const updateBreadCrumb = menuPath => {
    // console.log('updateBreadCrumb', window.location.search)
    const parsedSearch = queryParse(window.location.search)
    const urlBread = getUrlBreadCrumb(parsedSearch)
    const breadCrumb = menuPath
      .slice(2, menuPath.length - 1)
      .filter(d => d.path)
      .map(d => {
        const appPath = d.appPath || d.apppath
        const routeList = [...urlBread, ...routeHistory]
        for (const historyPath of routeList) {
          const keys = []
          const regexp = pathToRegexp(d.path.replace(appPath, ''), keys)
          const result = regexp.exec(historyPath.split('?')[0].replace(appPath, ''))
          if (result) {
            let navPath = historyPath.split('?')[0].replace(appPath, '')
            if (navPath.startsWith('$/')) {
              navPath = navPath.replace('$/', '/')
            }
            const pathSearch = queryParse(historyPath.split('?')[1] || '')
            delete pathSearch['bread']
            return {
              ...d,
              path: navPath + queryCompile(pathSearch),
            }
          }
        }
        return d
      })

    const breadText = breadCrumb.map(d => d.path).join(',')
    if (breadText) {
      parsedSearch['bread'] = encodeURIComponent(breadText)
      const replaceUrl = `${window.location.pathname}${queryCompile(parsedSearch)}`
      navigate(replaceUrl, {
        replace: true,
      })
    }
    // console.log('breadCrumb', breadCrumb.map(d => d.path).join(','))
    // console.log(breadText)
    setTimeout(() => {
      triggerEvent('UPDATE_BREADCRUMB', { breadCrumb })
      sessionStorage.setItem('BREADCRUMB', JSON.stringify(breadCrumb))
    }, 0)
  }

  const updateMenuSelect = () => {
    if (!selectedApp) return
    // console.log('updateMenuSelect', selectedApp)
    let parents: any[] = []
    let menuPath: any[] = []
    const pathName = window.location.pathname
    // const resourceItem = menuSource.find((d) => d.key === selectedApp.code)
    dfs(selectedApp?.children || [], d => {
      parents = parents.slice(0, d.level)
      parents[d.level] = d
      if (d.path) {
        const matchList = [
          pathToRegexp(d.path.replace(/^\$\//g, '/')),
          // pathToRegexp(d.path + '/details/:id'),
          // pathToRegexp(d.path + '/detail/:id'),
        ]
        const microPath = pathName.split('?')[0].replace(d.apppath, '')
        const mainPath = pathName.split('?')[0]

        if (matchList.find(matchItem => matchItem.exec(mainPath) || matchItem.exec(microPath))) {
          // console.log(parents)
          menuPath = Array.from(parents)
          return true
        }
      }
    })
    // console.log('menuPath', menuPath, selectedApp.children, location.pathname)
    // 菜单 level = 1
    if (menuPath[1]) {
      updateSelectedMenu(menuPath[1])
      menuRouteDict.current['selectedMenu'] = menuPath[1]
    }
    // console.log('menuPath', menuPath)
    // 子菜单 level = 2
    if (menuPath[2]) {
      updateSelectedSubMenu(menuPath[2])
    }
    updateBreadCrumb(menuPath)

    if (menuPath.length) {
      setMenuKeys([menuPath[menuPath.length - 1]?.key])
    }
  }

  useEffect(() => {
    console.log('selectedApp', selectedApp)
    setMenusNumber()
    window.addEventListener('resize', setMenusNumber)
    window.addEventListener('UPDATE_MENU_SIZE', setMenusNumber)

    setTimeout(() => {
      updateMenuSelect()
    }, 0)

    return () => {
      window.removeEventListener('resize', setMenusNumber)
      window.removeEventListener('UPDATE_MENU_SIZE', setMenusNumber)
    }
  }, [selectedApp])

  useEffect(() => {
    const cancelCallback = microApp.router.afterEach((to, from, appName) => {
      // console.log('to',routePathRef.current , to.pathname + to.search)
      if (routePathRef.current != to.pathname + to.search) {
        saveRouteHistory(to.pathname + to.search)
        updateMenuSelect()
      }
    })
    const nextPath = window.location.pathname + window.location.search
    if (routePathRef.current != nextPath) {
      routePathRef.current = nextPath
      saveRouteHistory(routePathRef.current)
      updateMenuSelect()
    }
    // console.log('location.pathname', window.location.pathname + window.location.search)
    return () => {
      cancelCallback?.()
    }
  }, [selectedApp, location.pathname])

  useEffect(() => {
    setSubMenus()
    window.addEventListener('resize', setSubMenus)
    window.addEventListener('UPDATE_MENU_SIZE', setSubMenus)
    return () => {
      window.removeEventListener('resize', setSubMenus)
      window.removeEventListener('UPDATE_MENU_SIZE', setSubMenus)
    }
  }, [selectedMenu])

  const menuOnload = data => {
    const { selectedGlobalMenuItem } = data.detail
    if (!selectedGlobalMenuItem) {
      setMenuLevel(1)
    }
  }

  useLayoutEffect(() => {
    const parsedSearch = queryParse(window.location.search)
    const urlBread = getUrlBreadCrumb(parsedSearch)
    urlBread.map(d => saveRouteHistory(d))

    window.addEventListener('MENU_ON_LOAD', menuOnload)
    return () => {
      window.removeEventListener('MENU_ON_LOAD', menuOnload)
    }
  }, [])

  const handleClose = () => {
    Modal.confirm({
      title: '提示',
      content: <>是否关闭当前应用并返回工作台 ?</>,
      onOk: () => {
        navigate('/main', { replace: true })
      },
    })
  }

  const handleSelectMenu = menu => {
    updateSelectedMenu(menu)
    menuRouteDict.current['selectedMenu'] = menu
    if (!menu.children) {
      menuClick(menu)
      setMenuLevel(1)
    } else {
      if (
        menu?.children?.length < 1 ||
        (menu?.children?.length === 1 && menu?.children?.[0]?.name === menu?.name)
      ) {
        setMenuLevel(1)
      } else {
        setMenuLevel(2)
      }
      const defaultSubMenu = menuRouteDict.current[menu.nid] || menu.children?.[0]
      if (defaultSubMenu) {
        selectSubMenu(defaultSubMenu)
      }
    }
  }

  const selectSubMenu = subMenu => {
    menuClick(subMenu)
    updateSelectedSubMenu(subMenu)
    menuRouteDict.current[menuRouteDict.current['selectedMenu']?.nid] = subMenu
  }

  const onExtraMenuClick = ({ item, key, keyPath, domEvent }) => {
    const menu = state.extraMenus.find(d => d.key === key)
    selectSubMenu(menu)
  }

  const onMainMenuClick = ({ item, key, keyPath, domEvent }) => {
    const menu = selectedApp?.children?.find(d => d.key === key)
    handleSelectMenu(menu)
  }

  return (
    <div className={styles.menuTop}>
      <div className={styles.topBox}>
        <div className={styles.selectAppTitle}>{selectedApp?.name}</div>
        {selectedApp?.children?.slice(0, mainMenuNumber)?.map(d => {
          return (
            <div
              style={{
                position: 'relative',
                backgroundColor: selectedMenu?.key === d.key ? 'rgb(246, 248, 251)' : 'transparent',
              }}
            >
              <div
                key={d.key}
                className={classNames(styles.topMenuItem, {
                  [styles.active]: selectedMenu?.key === d.key,
                })}
                onClick={() => handleSelectMenu(d)}
              >
                {d.name}
                {d?.children?.length === 1 && d?.children?.[0]?.name === d?.name ? (
                  <a
                    style={{
                      height: '100%',
                      width: '100%',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                    }}
                    onClick={e => {
                      e.preventDefault()
                    }}
                    href={
                      d?.children?.[0]?.path?.includes?.('http') ||
                      d?.children?.[0]?.path?.includes?.('https')
                        ? d?.children?.[0]?.path
                        : window.location.origin + d?.children?.[0]?.path
                    }
                  ></a>
                ) : null}
              </div>
            </div>
          )
        })}
        {mainMenuNumber < selectedApp?.children?.length ? (
          <Dropdown
            menu={{
              onClick: onMainMenuClick,
              items: selectedApp?.children
                ?.slice(mainMenuNumber, selectedApp?.children?.length)
                ?.map(d => ({
                  key: d.key,
                  label: (
                    <div
                      style={{
                        position: 'relative',
                        fontWeight: 500,
                        color: selectedMenu?.key === d.key ? 'var(--theme-color)' : '#575859',
                      }}
                    >
                      {d.name}
                      {d?.children?.length === 1 && d?.children?.[0]?.name === d?.name ? (
                        <a
                          style={{
                            height: '100%',
                            width: '100%',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                          }}
                          onClick={e => {
                            e.preventDefault()
                          }}
                          href={
                            d?.children?.[0]?.path?.includes?.('http') ||
                            d?.children?.[0]?.path?.includes?.('https')
                              ? d?.children?.[0]?.path
                              : window.location.origin + d?.children?.[0]?.path
                          }
                        ></a>
                      ) : null}
                    </div>
                  ),
                })),
            }}
          >
            <Button
              type="text"
              size="small"
              style={{ color: '#575859', fontWeight: 500 }}
              onClick={e => e.preventDefault()}
            >
              <Row gutter={4} align="middle" wrap={false}>
                <Col>更多</Col>
                <Col style={{ lineHeight: 0 }}>
                  <MenuDownArrow />
                </Col>
              </Row>
            </Button>
          </Dropdown>
        ) : null}
        <Button
          icon={<CloseOutlined />}
          type="text"
          style={{ marginLeft: 'auto', marginRight: 10 }}
          onClick={handleClose}
        />
      </div>
      {/* 子菜单只有一个时隐藏 */}
      <div
        className={classNames(styles.menuBox, {
          [styles.hasExtra]: state.extraMenus.length,
          [styles.hidden]: menuLevel === 1,
        })}
        ref={menuBoxRef}
      >
        {state.subMenus.map(d => {
          return (
            <div
              key={d.key}
              className={classNames(styles.subMenuItem, {
                [styles.active]: selectedSubMenu?.key === d.key,
              })}
              onClick={() => selectSubMenu(d)}
            >
              {d.name}
              <a
                style={{
                  height: '100%',
                  width: '100%',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
                onClick={e => {
                  e.preventDefault()
                }}
                href={
                  d.path?.includes?.('http') || d.path?.includes?.('https')
                    ? d.path
                    : window.location.origin +
                      (d?.apppath === '/'
                        ? d.path?.startsWith('$')
                          ? d.path?.replace('$', '')
                          : d.path
                        : d?.apppath + d.path)
                }
              ></a>
            </div>
          )
        })}

        {state.extraMenus.length ? (
          <Dropdown
            menu={{
              onClick: onExtraMenuClick,
              items: state.extraMenus.map(d => ({
                key: d.key,
                label: (
                  <div
                    className={classNames(styles.extraMenuItem, {
                      [styles.active]: selectedSubMenu?.key === d.key,
                    })}
                  >
                    {d.label}
                    <a
                      style={{
                        height: '100%',
                        width: '100%',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                      }}
                      onClick={e => {
                        e.preventDefault()
                      }}
                      href={
                        d.path?.includes?.('http') || d.path?.includes?.('https')
                          ? d.path
                          : window.location.origin +
                            (d?.apppath === '/'
                              ? d.path?.startsWith('$')
                                ? d.path?.replace('$', '')
                                : d.path
                              : d?.apppath + d.path)
                      }
                    ></a>
                  </div>
                ),
              })),
            }}
          >
            <Button
              type="text"
              size="small"
              style={{ color: '#575859' }}
              onClick={e => e.preventDefault()}
            >
              <Row gutter={4} align="middle" wrap={false}>
                <Col>更多</Col>
                <Col style={{ lineHeight: 0 }}>
                  <MenuDownArrow />
                </Col>
              </Row>
            </Button>
          </Dropdown>
        ) : null}
      </div>
    </div>
  )
})

export default MenuTop
